<template>
  <div :class="[classDiv, 'placeholder-glow']">
    <div class="form-floating mb-3">
      <select :class="['form-control', tam_input, class_placeholder]" :multiple="multiple" :id="name" :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)" :name="name" :required="required">

      </select>
      <label :for="name">{{ label }}</label>
    </div>
  </div>
</template>

<script>
import { toastr } from '@/plugins/toast';
import { api } from '@/services/api';
import { AuthStore } from '@/stores/Auth';

export default {
  name: 'InputSelect',
  components: {

  },
  props: {
    tamanho: {
      default: "sm",
    },
    name: {
      default: 'cat'
    },
    label: {
      default: 'Categoria'
    },
    dados: {
      default: [
        // { valor: '', texto: 'Selecione' },
      ]
    },
    multiple: Boolean,
    ativa_placeholder: {
      default: false,
    },
    primeiro_vazio: null,
    api_link: null,
    modelValue: '',
    classDiv: String,
    required: {
      default: false,
    },
  },
  data() {
    return {
      auth: AuthStore()
    }
  },
  methods: {
    async carrega_api() {
      if (this.api_link != null) {
        try {
          var dados = await api.post(this.api_link, {}, { Authorization: this.auth.token })
          if (dados.length > 0) {
            const s = document.querySelector('#' + this.name)

            if(this.primeiro_vazio){
              s.appendChild(new Option(this.primeiro_vazio, ""))
            }

            dados.forEach(function (opt, valor) {
              s.appendChild(new Option(opt.texto, opt.valor))
            });
          }
        } catch (error) {
          toastr.erro("Falha ao carregar dados.");
        }
      }
    }
  },
  computed: {
    tam_input: function () {
      if (this.tamanho == "") {
        return "";
      } else {
        return "form-control-" + this.tamanho;
      }
    },
    opcoes: function () {
      if (this.dados.length > 0) {
        const s = document.querySelector('#' + this.name)

        this.dados.forEach(function (opt, valor) {
          if (opt.texto != '') {
            s.appendChild(new Option(opt.texto, opt.valor))
          }
        });
      }
    },
    class_placeholder: function () {
      return (this.ativa_placeholder ? 'placeholder' : '')
    }
  },
  mounted() {
    this.opcoes;
    if (this.api_link) {
      this.carrega_api()
    }
  },
}
</script>

<style scoped></style>